'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const trackEvent = (
  eventName: string,
  params?: Record<string, string | number>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};


export default function GoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!window.gtag) return;

    const query = searchParams.toString();
    const url = query ? `${pathname}?${query}` : pathname;
    window.gtag('config', 'G-SL1J4ESV58', {
      page_path: url,
    });
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18051220128/y6XDCK3OpJIcEKCFv59D',
      'value': 1.0,
      'currency': 'THB',
      'page_path': window.location.pathname
    });
  }, [pathname, searchParams]);

  return null;
}
